//별별책방 - 본사 - 콘텐츠별 사용량 메인 페이지
import React, { Component } from "react";

import axios from "@app/lib/axios";

import * as Constant from "@app/Constant.js";
import ReactEcharts from "echarts-for-react";
import playddStyle from "../components/style";

import CardStatContent, { CardStatActivity } from "../components/CardStatContent";
import ContentBranchNurseryList from "./ActivityList";

class Activity extends Component {
    constructor(props) {
        super(props);
        this.state = {
            stat: null,
            totalNuriSub: { playCount : 0, playCountSum: 0},
            totalCoding: { playCount : 0, playCountSum: 0},
            totalEng: { playCount : 0, playCountSum: 0},
            totalKor: { playCount : 0, playCountSum: 0},
            contentSum: null,
            sortOption: { colId: "nurseryName", sort: "asc" },
            optionContent: null,
            colorContentSum: false,
        };
    }

    componentDidMount() {
        this.getStat();
    }

    componentWillReceiveProps = (nextProps) => {
        if (this.props.branchId != nextProps.branchId || this.props.statPeriod != nextProps.statPeriod) {
            this.setState(
                {
                    stat: null,
                },
                () => {
                    this.getStat();
                }
            );
        }
    };

    onListSortChanged = (colId, sort) => {
        this.setState({ sortOption: { colId, sort } });
    };
    getExcelData = (callback) => {
        const { isRoleBranch, branchName } = this.props;
        var stat = JSON.parse(JSON.stringify(this.state.stat));

        const excelData = {
            fileName: "플레이딩동_콘텐츠통계",
            sheets: [
                {
                    name: "콘텐츠별통계",
                    title: `콘텐츠별 통계`,
                    columnTitle: ["콘텐츠 명", "콘텐츠 타입", "콘텐츠 ID", "구분", "카테고리", "순 실행 수", "누적 실행 수"],
                    data: stat ? stat.map((s) => [s.activityName, s.activityType, s.activityId, s.division, s.categoryName ? s.categoryName : "누리", s.playCount, s.playCountSum]) : [],
                },
            ],
        };
        callback(null, excelData);
    };
    getStat = () => {
        axios({
            headers: {
                "Content-Type": "application/json",
            },
            method: "POST",
            url: Constant.API_DOMAIN + `/api/playdd/stat/hq/contents`,
            data: {
                startDate: this.props.statPeriod.startDate,
                endDate: this.props.statPeriod.endDate,
            },
        })
            .then((result) => {
                if (result.data.code === 200) {
                    var stat = result.data.data.content;
                    var totalNuriSub = { playCount : 0, playCountSum: 0};
                    var totalCoding = { playCount : 0, playCountSum: 0};
                    var totalEng = { playCount : 0, playCountSum: 0};
                    var totalKor = { playCount : 0, playCountSum: 0};

                    var content = [
                        { id: "playCount1", name: "저작툴", value: 0 },
                        { id: "playCount2", name: "활동지", value: 0 },
                        { id: "playCount3", name: "액티비티", value: 0 },
                        { id: "playCount4", name: "영상", value: 0 }
                    ];

                    stat.map((s) => {

                        if(s.division == "subject"){
                            s.division = "주제별"
                            totalNuriSub.playCount += s.playCount;
                            totalNuriSub.playCountSum += s.playCountSum
                        }
                        else if(s.division == "nuri") {
                            s.division = "누리"
                            totalNuriSub.playCount += s.playCount;
                            totalNuriSub.playCountSum += s.playCountSum
                        }
                        else if(s.division == "collabo") {
                            s.division = "협동그림"
                        }
                        else if(s.division == "coding") {
                            s.division = "코딩"
                            totalCoding.playCount += s.playCount;
                            totalCoding.playCountSum += s.playCountSum
                        }
                        else if(s.division == "pg") {
                            s.division = "딩동놀이터"
                        }

        
                        if (s.categoryName == "한글") {
                            totalKor.playCount += s.playCount;
                            totalKor.playCountSum += s.playCountSum
                        }
                        if (s.categoryName == "영어") {
                            totalEng.playCount += s.playCount;
                            totalEng.playCountSum += s.playCountSum
                        }

                        if (s.activityType == "저작툴") {
                            content[0].value += s.playCount;
                        }
                        if (s.activityType == "활동지") {
                            content[1].value += s.playCount;
                        }
                        if (s.activityType == "액티비티") {
                            content[2].value += s.playCount;
                        }
                        if (s.activityType == "영상") {
                            content[3].value += s.playCount;
                        }
                    })

                    const optionContent = {
                        tooltip: {
                            trigger: "item",
                            backgroundColor: "rgba(50,50,50,0.9)",
                            formatter: (params, chart, test) => {
                                const total = content ? content.reduce((ac, current) => ac + current.value, 0) : 0;
                                const tip = content
                                    ? content
                                          .map(
                                              (s, idx) =>
                                                  `<div class='row' style='margin-left: 3px;margin-right: 3px;width: 200px'>${`<span style="display:inline-block;margin-right:5px;border-radius:10px;width:10px;height:10px;background-color:${playddStyle.seriesContentColor.normal[idx]};"></span>`}${
                                                      s.name
                                                  }: ${s.value.toLocaleString()}, ${((s.value / total) * 100).toFixed(1)}%</div>`
                                          )
                                          .join("")
                                    : "";
                                return (
                                    tip +
                                    `<div style="height: 1px;border-bottom: 1px solid #aaa"></div><div class='row font-weight-bold m-1' style='width: 200px'>합계: ${total.toLocaleString()}</div>`
                                );
                            },
                        },
                        legend: {
                            orient: "vertical",
                            x: "75%",
                            y: "20%",
                        },
                        series: [
                            {
                                type: "pie",
                                data: content,
                                radius: ["0%", "80%"],
                                center: ["35%", "47%"],
                                animation: false,
                                labelLine: {
                                    show: false,
                                },
                                label: {
                                    show: false,
                                    position: "center",
                                },
                                color: playddStyle.seriesContentColor.normal,
                            },
                        ],
                    };
                  
                    this.setState({
                        stat,
                        optionContent,
                        totalNuriSub,
                        totalCoding,
                        totalEng,
                        totalKor
                    });
                } else {
                    alert(result.data && result.data.msg ? result.data.msg : "통계 정보를 가져오는데 실패하였습니다.\n지속 발생시 관리자에게 문의해주세요.");
                }
            })
            .catch((error) => {
                console.log(error);
                console.error("알 수 없는 오류가 발생하였습니다. \n지속 발생시 관리자에게 문의해주세요.");
            });
    };

    onSelectNursery = (nurseryId, nurseryName) => {
        if (this.props.onSelectNursery) {
            this.props.onSelectNursery(nurseryId, nurseryName);
        }
    };

    render() {
        const { stat, totalNuriSub, totalCoding, totalEng, totalKor, optionContent } = this.state;
        const { isRoleBranch } = this.props;
        return (
            <div className="stat-branch-content">
                <div className="row">
                    <div className="col-xl-8 col-lg-8 col-md-12 col-sm-12 col-12">
                        <div className="card">
                            <div className="card-header d-flex" style={{ padding: "5px 20px" }}>
                            </div>
                            <div className="card-body" style={{ height: "200px" }}>
                                <div className="row">
                                    <div className="col-xl-3 col-lg-3 col-md-3 col-sm-3 col-3">
                                        <CardStatActivity id="1" title={`누리 + 주제별`}  total={totalNuriSub.playCount} totalSum={totalNuriSub.playCountSum} titleBgClass="bg-tomonote" />
                                    </div>
                                    <div className="col-xl-3 col-lg-3 col-md-3 col-sm-3 col-3">
                                        <CardStatActivity id="1" title={`코딩`} total={totalCoding.playCount} totalSum={totalCoding.playCountSum} titleBgClass="bg-tomonote" />
                                    </div>
                                    <div className="col-xl-3 col-lg-3 col-md-3 col-sm-3 col-3">
                                        <CardStatActivity id="1" title={`영어`} total={totalEng.playCount} totalSum={totalEng.playCountSum} titleBgClass="bg-tomonote" />
                                    </div>
                                    <div className="col-xl-3 col-lg-3 col-md-3 col-sm-3 col-3">
                                        <CardStatActivity id="1" title={`한글`} total={totalKor.playCount} totalSum={totalKor.playCountSum} titleBgClass="bg-tomonote" />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-xl-4 col-lg-4 col-md-12 col-sm-12 col-12">
                        <div className="card">
                            <div className="card-header d-flex" style={{ padding: "5px 20px" }}>
                                <h4 className="card-header-title">콘텐츠 타입별 사용 현황</h4>
                            </div>

                            <div className="card-body" style={{ height: "190px" }}>
                                <div className="row">
                                    <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                                        {optionContent && <ReactEcharts theme="macarons" option={optionContent} style={{ height: `167px` }} />}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col">
                        <ContentBranchNurseryList
                            isRoleBranch={isRoleBranch}
                            data={stat}
                            height="500"
                            onRowClick={this.onSelectNursery.bind(this)}
                            onListSortChanged={this.onListSortChanged.bind(this)}
                        />
                    </div>
                </div>
                {isRoleBranch && (
                    <div className="row mb-3">
                        <div className="col-12">
                            <div className="text-xs text-primary float-right">
                                ※ 정확한 통계 제공을 위해 현재 날짜의 전일까지의 통계만 제공됩니다.
                                <br />※ 당해 학년도의 3월~2월까지의 통계 데이터만 제공됩니다.
                            </div>
                        </div>
                    </div>
                )}
            </div>
        );
    }
}

export default Activity;
